<template>
  <div>
    <slider />
    <div class="main-container">
      <top />
      <appmain />
    </div>
  </div>
</template>
<script>
import slider from "./components/slider.vue";
import appmain from "./components/appmain.vue";
import top from "./components/top.vue";
export default {
  name: "Layout",
  components: {
    slider,
    appmain,
    top
  },
};

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue